import React from "react";
import ImageList from "~/apps/cartario/components/ImageList.tsx";
import {AppDispatch} from "~/store";
import {useDispatch, useSelector} from "react-redux";
import {fetchProducts} from "~/store/shopifySlice.ts";

interface ShopifyImage {
    product_id: number;
    title: string;
    image_id: number;
    width: number;
    height: number;
    src: string;
}


const ProductImages: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const productImages = useSelector((state: any) => state.shopify.productImages);

    React.useEffect(() => {
        dispatch(fetchProducts());
    }, [dispatch]);

    const formattedImages = React.useMemo(() => {
        return (productImages || []).map((image: ShopifyImage) => ({
            id: image.image_id.toString(),
            title: image.title,
            description: `Product ID: ${image.product_id}`,
            dimensions: `${image.width}px × ${image.height}px`,
            src: image.src,
            size: `${((image.width * image.height) / (1024 * 1024)).toFixed(2)}MP`
        }));
    }, [productImages]);

    console.log(productImages);
    console.log(formattedImages);

    return <ImageList images={formattedImages} type="product" />;
};

export default ProductImages;
